import { useEffect, useState, useRef } from "react";
import { toast } from "sonner";
import { Upload, Trash2, Copy, FileText, Film, Loader2 } from "lucide-react";
import api, { formatApiError, mediaUrl } from "@/lib/api";
import { PageHeader, Card, EmptyState } from "@/components/admin/AdminUI";

export default function MediaAdmin() {
  const [items, setItems] = useState([]);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  const load = () => api.get("/admin/media").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      await api.post("/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Fichier téléversé");
      load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setUploading(false); if (fileRef.current) fileRef.current.value = ""; }
  };

  const remove = async (id) => { await api.delete(`/admin/media/${id}`); load(); };
  const copyUrl = (path) => { navigator.clipboard.writeText(`${window.location.origin}${mediaUrl(path)}`); toast.success("URL copiée"); };

  return (
    <div>
      <PageHeader title="Médiathèque" subtitle="Images, logos, vidéos et documents."
        action={<button onClick={() => fileRef.current?.click()} disabled={uploading} data-testid="media-upload-button" className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-[#3B82F6] text-white text-sm font-semibold disabled:opacity-60">{uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Téléverser</button>} />
      <input ref={fileRef} type="file" className="hidden" onChange={upload} />
      {items.length === 0 ? <Card><EmptyState text="Aucun fichier. Téléversez votre premier média." /></Card> : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4" data-testid="media-grid">
          {items.map((m) => (
            <Card key={m.id} className="overflow-hidden group">
              <div className="h-32 bg-[#0B0F17] grid place-items-center overflow-hidden">
                {m.kind === "image" ? <img src={mediaUrl(m.storage_path)} alt={m.original_filename} className="w-full h-full object-cover" />
                  : m.kind === "video" ? <Film className="w-10 h-10 text-slate-600" /> : <FileText className="w-10 h-10 text-slate-600" />}
              </div>
              <div className="p-3">
                <div className="text-xs text-slate-300 truncate">{m.original_filename}</div>
                <div className="flex items-center gap-1 mt-2">
                  <button onClick={() => copyUrl(m.storage_path)} className="p-1.5 rounded-lg text-slate-400 hover:text-white hover:bg-[#1E293B]"><Copy className="w-3.5 h-3.5" /></button>
                  <button onClick={() => remove(m.id)} className="p-1.5 rounded-lg text-slate-400 hover:text-rose-400 hover:bg-[#1E293B]"><Trash2 className="w-3.5 h-3.5" /></button>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
